<template>
  <div class="forward-looking-information">
    <information button-title="איך המידע שלי מאובטח?" :button-action="next"
                 animation-name="forward-looking.json">
      <template v-slot:information-title>
        <div>בניגוד לעו״ש שמסתכל אחורה,</div>
        <div>התזרים שלך מסתכל קדימה</div>
      </template>
      <template v-slot:information-description>
        <div>
          על בסיס חודשי העבר, התזרים יודע לצפות כבר בתחילת החודש איך הוא הולך להיגמר. כמה כסף יכנס, כמה כסף יצא וכמה נשאר לך להוציא
        </div>
      </template>
    </information>
  </div>
</template>
<script>

import { mapActions } from 'vuex';
import Information from './components/Information';
import Segment from '../../../../../Segment';

export default {
  components: {
    Information,
  },
  name: 'ForwardLookingInformation',
  created() {
    Segment.trackUserGot('infoforwardlookingentered');
    Segment.trackUserGot('infoforwardlookingentered_Marketing');
  },
  methods: {
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    next() {
      this.onboardingPageSubmit();
      Segment.trackUserInteraction('infoforwardlookingnextclicked');
      Segment.trackUserInteraction('infoforwardlookingnextclicked_Marketing');
    },
  },
};
</script>

<style lang="scss">
  @import '~base-ui/src/scss/riseup-colors';

  .forward-looking-information {
    height: 100%;

    .information {

      .body {
        background-color: $riseup_light_red;
      }

      img {
        background-color: $riseup_light_red;
      }

      lottie-player {
        background-color:  $riseup_light_red;
      }
    }
  }

</style>
